export default "__VITE_ASSET__BTlwDpFA__"